import React, { useState } from "react";
import styled from "styled-components";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import FeedbackForm from "./FeedbackForm";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

const TestimonialsContainer = styled.div`
  font-family: "Poppins", sans-serif;
  background: #062c3f;
  padding: 30px 0;

  .lead {
    padding-bottom: 5rem;
    color: white;
  }

  .testimonial-card {
    padding: 2rem;
    background: white;
    box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    margin: 1rem;
  }

  .author-img img {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    object-fit: cover;
  }

  .quote {
    font-size: 3em;
    color: #07b6f2;
  }

  .heading-testimonials {
    font-weight: 700;
    font-size: 3em;
    color: #00cbf1;
    margin-bottom: 1.5rem;
  }

  .heading-testimonials span {
    color: white;
  }

  .text-muted {
    line-height: 1.9;
    margin-left: 0.6em;
  }

  .font-medium {
    font-weight: 500;
  }

  .comms {
    width: 60px;
    height: 60px;
    object-fit: contain;
  }

  .authorname {
    font-weight: 600;
    color: #06334b;
  }

  /* Feedback Button Styling */
.feedback-button {
  position: static;
  bottom: 30px;
  left: 30px;
  background: linear-gradient(45deg, #0f93f0, #06334b);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  color: white;
  padding: 8px 16px;
  font-size: 1rem;
  border-radius: 30px; /* Single border-radius declaration */
  font-weight: bold;
  transition: all 0.3s ease;
  z-index: 999; /* Ensure it stays on top */
  width: 220px;
  text-align: center; /* Center text alignment */
}

/* Hover Effects */
.feedback-button:hover {
  background: linear-gradient(45deg, #06334b, #0f93f0);
  color: #fff;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.3);
  transform: translateY(-3px);
}

/* Focus Outline */
.feedback-button:focus {
  outline: none;
}

/* Responsive Styling */
@media (max-width: 768px) {
  .feedback-button {
    font-size: 0.9rem; /* Slightly smaller font for smaller screens */
    padding: 6px 12px;
    width: 180px;
  }
}

@media (max-width: 480px) {
  .feedback-button {
    font-size: 0.8rem; /* Even smaller font for very small screens */
    padding: 5px 10px;
    width: 150px;
    bottom: 20px; /* Adjust spacing */
    left: 20px;
  }
}

`;

const TestimonialsSection = () => {
  
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const navigate = useNavigate();

  const testimonialsData = [
    {
      imgSrc: "https://annedece.sirv.com/Images/commos.png",
      description:
        "NexTech proved to be a valuable partner in our recent PLM implementation. Their expertise in Teamcenter and understanding of our specific needs were evident throughout the project. The team was responsive, communicative, and dedicated to ensuring a successful outcome. We're pleased with the results and the positive impact it has had on our product development process.",
      extraInfo:
        "",
      authorImg:
        "https://annedece.sirv.com/Images/pexels-andrea-piacquadio-762020%20(1).jpg",
      authorName: "Lorem Rich1",
      authorRole: "CEO",
    },
    {
      imgSrc: "https://annedece.sirv.com/Images/commos.png",
      description:
        "We were impressed by NexTech's collaborative approach and commitment to customer satisfaction. They listened carefully to our needs and tailored their solutions accordingly. Their team is highly knowledgeable and responsive, ensuring a smooth implementation process.",
      extraInfo:
        "",
      authorImg:
        "https://annedece.sirv.com/Images/pexels-andrea-piacquadio-762020%20(1).jpg",
      authorName: "Lorem Rich1",
      authorRole: "Manager",
    },
    
   
  
    // Add more testimonials here
  ];

  return (
    <TestimonialsContainer>
      <div className="container mt-5">
        <div className="row">
          <div className="col-12 col-lg-12 mx-auto">
            <h4 className="heading-testimonials">
              What Our <span>Client Say?</span>
            </h4>
          </div>
          <div className="col-12 testimonials">
            <OwlCarousel
              className="owl-theme"
              loop={false}
              margin={20}
              nav={false}
              dots={true}
              responsive={{
                0: { items: 1 },
                600: { items: 1 },
                1000: { items: 2 },
              }}
            >
              {testimonialsData.length > 0 ? (
                testimonialsData.map((testimonial, index) => (
                  <div className="testimonial-card" key={index}>
                    <i className="fa-solid fa-quote-left quote"></i>
                    <p className="text-muted">{testimonial.description}</p>
                    <p className="text-muted pb-4">{testimonial.extraInfo}</p>
                    <hr />
                    <div className="d-flex align-items-center pt-3">
                      <div className="author-img mr-3">
                       {/* <img src={testimonial.authorImg} alt={testimonial.authorName} />*/}
                      </div>
                      <div>
                        {/*<h5 className="m-0 authorname">{testimonial.authorName}</h5>*/}
                        <h5 className="m-0 small font-medium text-muted">
                          {testimonial.authorRole}
                        </h5>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No testimonials available.</p>
              )}
            </OwlCarousel>
          </div>
          <button
            className="feedback-button"
            onClick={() => navigate("/feedback")}
          >
            Share Your Feedback
          </button>
      </div>
      </div>
      {showFeedbackForm && <FeedbackForm onClose={() => setShowFeedbackForm(false)} />}
    </TestimonialsContainer>
  );
};

export default TestimonialsSection;
